import { render, staticRenderFns } from "./RemoteControllerList.vue?vue&type=template&id=2e660b24&scoped=true"
import script from "./RemoteControllerList.vue?vue&type=script&lang=js"
export * from "./RemoteControllerList.vue?vue&type=script&lang=js"
import style0 from "./RemoteControllerList.vue?vue&type=style&index=0&id=2e660b24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e660b24",
  null
  
)

export default component.exports